const clamp = (value, min, max) => Math.min(Math.max(value, min), max);

export const clampCropRect = (rect, minSize = 0.05) => {
  const w = clamp(rect.w, minSize, 1);
  const h = clamp(rect.h, minSize, 1);
  let x = clamp(rect.x, 0, 1 - w);
  let y = clamp(rect.y, 0, 1 - h);
  return { x, y, w, h };
};

export const updateCropRect = ({ rect, handle, startPoint, currentPoint, minSize = 0.05 }) => {
  const dx = currentPoint.x - startPoint.x;
  const dy = currentPoint.y - startPoint.y;
  let next = { ...rect };

  if (handle === 'move') {
    next.x = rect.x + dx;
    next.y = rect.y + dy;
    return clampCropRect(next, minSize);
  }

  if (handle.includes('e')) {
    next.w = rect.w + dx;
  }
  if (handle.includes('s')) {
    next.h = rect.h + dy;
  }
  if (handle.includes('w')) {
    next.x = rect.x + dx;
    next.w = rect.w - dx;
  }
  if (handle.includes('n')) {
    next.y = rect.y + dy;
    next.h = rect.h - dy;
  }

  return clampCropRect(next, minSize);
};

export const getNormalizedPoint = (event, bounds) => {
  const x = (event.clientX - bounds.left) / bounds.width;
  const y = (event.clientY - bounds.top) / bounds.height;
  return {
    x: clamp(x, 0, 1),
    y: clamp(y, 0, 1),
  };
};
